// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type PropertyUri from '../contract/PropertyUri';

export default function propertyUri(data: PropertyUri): PropertyUri {
    const result: PropertyUri = {
        __type: 'PropertyUri:#Exchange',
        ...data,
    };

    return result;
}
